<ion-card *ngIf="auth.loggedInEmployee">
  <ion-row class="pading5" *ngIf="auth.loggedInEmployee?.user">
    <ion-col size="4"> </ion-col>
    <ion-col size="4" sizeMd="2" class="floatCentre textCenter">
      <app-attachment-display (onUpload)="afterUpload($event)" [(attachmentUrl)]="auth.loggedInEmployee.user.url"
        [type]="'IMAGE'" [path]="'vanshavali/profileImg/'" [canEdit]="true">
      </app-attachment-display>
    </ion-col>
    <ion-col size="4"> </ion-col>
    <ion-col class="padding5" size="6" sizeMd="6">
      <app-a-input [label]="trans.translate('Name')" (onBlur)="onInputBlur('name')"
        [validations]="['mandatory',toastService.checkValidation,'name']"
        [validationObject]="auth.loggedInEmployee.user" [(variable)]="auth.loggedInEmployee.user.name"></app-a-input>
    </ion-col>

    <ion-col class="padding5" size="6" sizeMd="6">
      <app-a-input [label]="trans.translate('SurName')"
        [(variable)]="auth.loggedInEmployee.user.last_name"></app-a-input>
    </ion-col>

    <ion-col class="padding5" size="12" sizeMd="4" class="padding4">
      <app-date [label]="trans.translate('Birth Date')+ ' *'" [(model)]="auth.loggedInEmployee.user.dob"
        [minDate]="'1800-01-01'" [maxDate]="maxDate"></app-date>
    </ion-col>

    <ion-col class="padding5" size="12">
      <ion-label position="stacked">{{ 'Gender' | translate }} *</ion-label>
      <ion-radio-group [(ngModel)]="auth.loggedInEmployee.user.gender" class="radio-inline">
        <ion-item lines="none">
          <ion-label>{{ 'Male' | translate }}</ion-label>
          <ion-radio slot="end" value="MALE"></ion-radio>
        </ion-item>
        <ion-item lines="none">
          <ion-label>{{ 'Female' | translate }}</ion-label>
          <ion-radio slot="end" value="FEMALE"></ion-radio>
        </ion-item>
      </ion-radio-group>
    </ion-col>

    <ion-col class="margin5px" size="12">
      <ion-label position="stacked">{{ 'Marital Status' | translate }} *</ion-label>
      <ion-radio-group [(ngModel)]="auth.loggedInEmployee.user.user_pd.marital" class="radio-inline">
        <ion-item lines="none">
          <ion-label>{{ 'Married' | translate }}</ion-label>
          <ion-radio slot="end" value="Married"></ion-radio>
        </ion-item>
        <ion-item lines="none">
          <ion-label>{{ 'UnMarried' | translate }}</ion-label>
          <ion-radio slot="end" value="UnMarried"></ion-radio>
        </ion-item>
      </ion-radio-group>
    </ion-col>

    <ion-col size="12" sizeMd="4" class="padding4">
      <app-pincode [(variable)]="auth.loggedInEmployee.user.user_pd"></app-pincode>
    </ion-col>
    <!-- <ion-col size="12" sizeMd="4" class="padding5">
      {{auth.loggedInEmployee.user.user_pd.current_address2}}
    </ion-col> -->
    <ion-col size="12" sizeMd="4" class="padding4">
      <app-a-input [label]="trans.translate('Place of Origin / मूल निवास')+ ' *'"
        [(variable)]="auth.loggedInEmployee.user.user_pd.origin_city"></app-a-input>
    </ion-col>
    <ion-col size="12" sizeMd="4" class="padding4">
      <app-a-input [label]="'Email'" [(variable)]="auth.loggedInEmployee.user.user_pd.email"></app-a-input>
    </ion-col>
    <ion-col size="12" sizeMd="4" class="padding4">
      <ion-row>
        <ion-col size="5">
          <app-a-select [label]="'Code'" [(variable)]="auth.loggedInEmployee.user.user_pd.country_code"
            [objectList]="countryService.countries" [type]="'Object'" [value]="'code'"
            [display]="'displayLabel'"></app-a-select>
        </ion-col>
        <ion-col size="7">
          <app-a-input [label]="trans.translate('Mobile number')+ ' *'" (onBlur)="onBlurMobile()"
            [disabled]="isMobileLogin" [(variable)]="auth.loggedInEmployee.user.user_pd.mobile"></app-a-input>
        </ion-col>
      </ion-row>
    </ion-col>
    <ion-col size="12" sizeMd="4" class="padding4">
      <app-a-select [label]="trans.translate('Privacy')+ ' *'"
        [objectList]="['Hide Everything','Hide Contact Info','Open to connect']"
        [(variable)]="auth.loggedInEmployee.user.user_pd.privacy"></app-a-select>
    </ion-col>
  </ion-row>
</ion-card>